import React, { useState, useEffect } from 'react';
import { policyService } from '../services/api';

function Policies() {
  const [policies, setPolicies] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPolicies = async () => {
      try {
        const response = await policyService.getAll();
        if (response.data) {
          setPolicies(response.data);
        }
      } catch (error) {
        console.error('Error fetching policies:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchPolicies();
  }, []);

  if (loading) {
    return (
      <div className="bg-gray-50 min-h-screen">
        <div className="flex items-center justify-center h-64">
          <div className="text-gray-500">در حال بارگذاری...</div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-gray-50 min-h-screen">
      {/* Header */}
      <div className="bg-gradient-to-br from-blue-900 to-blue-800 text-white py-16">
        <div className="max-w-7xl mx-auto px-4">
          <h1 className="text-5xl font-bold mb-4">سیاست‌های نشریه</h1>
          <p className="text-xl text-blue-100">استانداردهای انتشار و اخلاقیات علمی</p>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-4 py-16">
        <div className="space-y-8">
          {policies.length > 0 ? (
            policies.map((policy) => (
              <section key={policy.id} className="bg-white rounded-xl shadow-md p-8">
                <h2 className="text-3xl font-bold text-gray-900 mb-6 flex items-center gap-3">
                  <span className="text-3xl">{policy.icon}</span>
                  {policy.title}
                </h2>
                <p className="text-gray-700 leading-relaxed">
                  {policy.description}
                </p>
              </section>
            ))
          ) : (
            <div className="bg-white rounded-xl shadow-md p-8 text-center text-gray-500">
              <p>اطلاعاتی برای نمایش وجود ندارد</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default Policies;
